<template>
<section class="about-us" :id="$t('routes.about')" :ref="$t('routes.about')">

    <div class="sloth-container">
        <h3 class="section-title text-center">
            {{ $t('navigation.about_us_title') }}
        </h3>
        <div class="about-team">
            <div class="about-team-cover floating">
                <img src="/assets/images/professional-teamwork-splash.svg" alt="">
            </div>
            <div class="about-team-content   ">
                <h2 class="about-team-title">
                    {{ $t('about.title')}}
                </h2>
                <p class="about-team-description">
                    {{ $t('about.description')}}
                </p>
            </div>
        </div>
    </div>

</section>
</template>

<script>
export default {
    name: "AboutUs"
}
</script>
